import { Store, Truck } from "lucide-react";
import { cn } from "@/lib/utils";
import type { FulfillmentMode } from "@/lib/types";

const OPTIONS: { mode: FulfillmentMode; label: string; Icon: typeof Truck }[] = [
  { mode: "ENTREGA", label: "Entrega por motorista", Icon: Truck },
  { mode: "RETIRADA", label: "Retirada na loja", Icon: Store },
];

/**
 * Escolha entre entregar o pedido com um motorista (ENTREGA) ou liberar para o
 * cliente retirar na fábrica (RETIRADA). Usado nos popups de "Liberar para entrega".
 */
export function FulfillmentModeToggle({
  value,
  onChange,
}: {
  value: FulfillmentMode;
  onChange: (mode: FulfillmentMode) => void;
}) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium">Tipo de saída</label>
      <div className="grid grid-cols-2 gap-2">
        {OPTIONS.map(({ mode, label, Icon }) => (
          <button
            key={mode}
            type="button"
            onClick={() => onChange(mode)}
            className={cn(
              "flex items-center justify-center gap-2 rounded-md border px-3 py-2 text-sm font-medium transition-colors",
              value === mode
                ? "border-primary bg-primary/10 text-primary"
                : "border-input text-muted-foreground hover:bg-secondary/50",
            )}
          >
            <Icon className="h-4 w-4" /> {label}
          </button>
        ))}
      </div>
    </div>
  );
}
